export default {"footerNavGroupTitleWrapper":"TsZH9","footerNavGroupTitleWrapperOpen":"_4D8n-","footerNavGroupTitleText":"yrwGg M3nQ1 UzvkT"};